import { products } from "../data/productData";

/** Explicit filter tags keyed by product id (Clinical Scrubs vs body scrub, etc.). */
export const PRODUCT_FILTER_TAGS = {
  1: { productType: "oil", area: ["body"] },
  2: { productType: "butter", area: ["body"] },
  3: { productType: "clinical-scrubs", area: ["medical"] },
  4: { productType: "sets", area: ["body", "face"] },
  5: { productType: "butter", area: ["body"] },
  6: { productType: "oil", area: ["body"] },
  7: { productType: "soap", area: ["body"] },
  8: { productType: "soap", area: ["face"] },
  9: { productType: "hair-oil", area: ["hair"] },
  10: { productType: "soap", area: ["face"] },
  11: { productType: "soap", area: ["face"] },
  12: { productType: "soap", area: ["body"] },
  13: { productType: "lash-kit", area: ["lashes"] },
  14: { productType: "cream", area: ["face"] },
  15: { productType: "serum", area: ["face"] },
  16: { productType: "lash-adhesive", area: ["lashes"] },
  17: { productType: "scrub", area: ["body"] },
  19: { productType: "face-mask", area: ["medical"] },
  20: { productType: "gloves", area: ["medical"] },
  21: { productType: "disposable-pads", area: ["medical"] },
  22: { productType: "sets", area: ["face", "body"] },
  23: { productType: "sets", area: ["body"] },
  24: { productType: "black-soap", area: ["body"] },
  25: { productType: "oil", area: ["body"] },
  26: { productType: "sunscreen", area: ["face"] },
  27: { productType: "soap", area: ["body"] },
  28: { productType: "cream", area: ["body"] },
  29: { productType: "cream", area: ["face"] },
  30: { productType: "toner", area: ["face"] },
  31: { productType: "oil", area: ["body"] },
  32: { productType: "sets", area: ["body", "face"] },
};

export const PRODUCT_TYPE_FILTERS = [
  { id: "soap", label: "Soap" },
  { id: "black-soap", label: "Black soap" },
  { id: "cream", label: "Cream" },
  { id: "butter", label: "Butter" },
  { id: "oil", label: "Oil" },
  { id: "scrub", label: "Body scrub" },
  { id: "serum", label: "Serum" },
  { id: "toner", label: "Toner" },
  { id: "sunscreen", label: "Sunscreen" },
  { id: "sets", label: "Sets & collections" },
  { id: "hair-oil", label: "Hair oil" },
  { id: "lash-kit", label: "Lash kit" },
  { id: "lash-adhesive", label: "Lash adhesive" },
  { id: "face-mask", label: "Face mask (PPE)" },
  { id: "gloves", label: "Gloves" },
  { id: "disposable-pads", label: "Disposable pads" },
  { id: "clinical-scrubs", label: "Clinical scrubs" },
];

export const AREA_FILTERS = [
  { id: "face", label: "Face" },
  { id: "body", label: "Body" },
  { id: "hair", label: "Hair" },
  { id: "lashes", label: "Lashes" },
  { id: "medical", label: "Medical / professional" },
];

export const getProductFilterTags = (product) => {
  const explicit = PRODUCT_FILTER_TAGS[product?.id];
  if (explicit) {
    return {
      productType: explicit.productType,
      area: Array.isArray(explicit.area) ? explicit.area : [explicit.area],
    };
  }

  return { productType: null, area: [] };
};

export const filterProducts = (
  productList,
  { productTypes = [], areas = [] } = {},
) => {
  const activeTypes = productTypes.filter(Boolean);
  const activeAreas = areas.filter(Boolean);

  return productList.filter((product) => {
    const tags = getProductFilterTags(product);

    const matchesType =
      activeTypes.length === 0 ||
      (tags.productType && activeTypes.includes(tags.productType));

    const matchesArea =
      activeAreas.length === 0 ||
      tags.area.some((area) => activeAreas.includes(area));

    return matchesType && matchesArea;
  });
};

export const getAvailableFilterCounts = (
  productList,
  { productTypes = [], areas = [] } = {},
) => {
  const activeTypes = productTypes.filter(Boolean);
  const activeAreas = areas.filter(Boolean);

  const typeCounts = Object.fromEntries(
    PRODUCT_TYPE_FILTERS.map(({ id }) => [id, 0]),
  );
  const areaCounts = Object.fromEntries(
    AREA_FILTERS.map(({ id }) => [id, 0]),
  );

  productList.forEach((product) => {
    const tags = getProductFilterTags(product);

    const matchesSelectedAreas =
      activeAreas.length === 0 ||
      tags.area.some((area) => activeAreas.includes(area));

    if (
      matchesSelectedAreas &&
      tags.productType &&
      typeCounts[tags.productType] !== undefined
    ) {
      typeCounts[tags.productType] += 1;
    }

    const matchesSelectedTypes =
      activeTypes.length === 0 ||
      (tags.productType && activeTypes.includes(tags.productType));

    if (matchesSelectedTypes) {
      tags.area.forEach((area) => {
        if (areaCounts[area] !== undefined) {
          areaCounts[area] += 1;
        }
      });
    }
  });

  return { typeCounts, areaCounts };
};

export const isProductVisible = (product) => !product?.hidden;

export const catalogProducts = products.filter(isProductVisible);
